import { inject, Injectable } from "@angular/core";
import { SyncStatusEnum } from "@bitwarden/web-vault/app/models/types/general-types";
import { AccountView } from "@bitwarden/web-vault/app/models/view/account/account.view";
import { GlossSyncService } from "@bitwarden/web-vault/app/services/syncing/gloss.sync.service";
import { BasiqJobSync } from "@bitwarden/web-vault/app/services/syncing/basiq/sync-levels/basiq.job.sync";
import { AppStateStoreService } from "@bitwarden/web-vault/app/services/store/app-state/app-state.store.service";
import { BasiqInstitutionValidator } from "@bitwarden/web-vault/app/services/syncing/basiq/validators/basiq.validator.institution";

@Injectable({
  providedIn: "root",
})
export class BasiqInstitutionSync {
  constructor(
    private appState: AppStateStoreService = inject(AppStateStoreService),
    private glossSyncService: GlossSyncService = inject(GlossSyncService),
    private basiqJobSync: BasiqJobSync = inject(BasiqJobSync),
    private basiqInstitutionValidator: BasiqInstitutionValidator = inject(
      BasiqInstitutionValidator,
    ),
  ) {}

  async run(instoBasiqId: string, accounts: AccountView[]) {
    try {
      if (!(await this.basiqInstitutionValidator.isValid(instoBasiqId))) {
        await this.glossSyncService.terminateSync(
          accounts,
          this.basiqInstitutionValidator.syncStatus,
        );
        return;
      }

      await this.runJobLevelSync(accounts);
    } catch (error) {
      await this.glossSyncService.logError(
        accounts,
        error,
        "Basiq insto level syncing",
        SyncStatusEnum.unknownError,
      );
      await this.glossSyncService.terminateSync(accounts, SyncStatusEnum.unknownError);
      this.appState.endProcess("basiq-syncing-data");
    }
  }

  async runJobLevelSync(accounts: AccountView[]): Promise<void> {
    await this.basiqJobSync.run(this.basiqInstitutionValidator.job, accounts);
  }
}
